//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Number,
    },
  },

  data() {
    return {
      checked: this.value,
    };
  },
  watch: {
    value(newVal) { 
      this.checked  = newVal
    }
  },
  methods: {
    change(val) {
      this.$emit('input', val);
      this.$emit('change');
    },
  },
};
